import { useSelector, useDispatch } from "react-redux";
import { Badge } from "antd";
import { toggleWidget } from "../../../Slices/chatSlice";
import { FiMessageCircle } from "react-icons/fi";

const ChatHeaderBadge = () => {
  const dispatch = useDispatch();
  const totalUnreadCount = useSelector((state) => state.chat.totalUnreadCount);

  return (
    <Badge count={totalUnreadCount} overflowCount={99} size="small">
      <FiMessageCircle
        style={{ fontSize: 20, cursor: "pointer", color: "white" }}
        onClick={() => dispatch(toggleWidget())}
        title="Chat"
      />
    </Badge>
  );
};

export default ChatHeaderBadge;
